import type { User } from 'pure-js/types/User'
import type { OrganizationMembership } from 'pure-js/types/OrganizationMembership'

/** Every explicitly held membership is a valid workspace choice. */
export function getVisibleOrgMemberships(user: User | null | undefined): OrganizationMembership[] {
  return user?.organizations ?? []
}
